<div class="p-fluid" [formGroup]="form">
  <kodit-field fieldLabel="Pošiljalac" fieldLabelFor="masovno-slanje-from">
    <kodit-email-dropdown [formCtrl]="form.controls.fromId"></kodit-email-dropdown>
  </kodit-field>
  <kodit-field fieldLabel="Naslov" fieldLabelFor="masovno-slanje-naslov">
    <kodit-text-input
      formCtrlId="masovno-slanje-naslov"
      [formCtrl]="form.controls.mailNaslov"
    ></kodit-text-input>
  </kodit-field>
  <kodit-field fieldLabel="Poruka" fieldLabelFor="masovno-slanje-poruka">
    <kodit-textarea-input
      formCtrlId="masovno-slanje-poruka"
      [formCtrl]="form.controls.customPoruka"
      ctrlPlaceholder="Opciono - ista poruka ide uz svaki predračun"
    ></kodit-textarea-input>
  </kodit-field>
  <div class="p-d-flex p-flex-column">
    <span class="note">
      *** Biće poslato {{ racunIds.length }} predračuna, svaki na sve email adrese iz kontakata kupca sa predračuna.
      Poslati predračuni prelaze u status Poslato, a datum izdavanja postaje datum slanja. Kupci bez ijednog kontakta
      sa email adresom neće dobiti predračun. Dobićete notifikaciju kada se slanje završi.
    </span>
  </div>
</div>
